import { render, staticRenderFns } from "./PrettyRoute.vue?vue&type=template&id=05d46d29&scoped=true"
import script from "./PrettyRoute.vue?vue&type=script&lang=js"
export * from "./PrettyRoute.vue?vue&type=script&lang=js"
import style0 from "./PrettyRoute.vue?vue&type=style&index=0&id=05d46d29&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d46d29",
  null
  
)

export default component.exports